import type { UserPermission } from '@contracts/users/UserPermission';

interface Attributes {
  email: string;
  name: string;
  id: string;
  extension?: string;
  isInactive: boolean;
  cognitoStatus: string;
  permissions: Set<UserPermission>;
}

export class User {
  public readonly id: string;
  public readonly email: string;
  public readonly name: string;
  public readonly extension?: string;
  public readonly isInactive: boolean;
  public readonly cognitoStatus: string;
  public readonly permissions: Set<UserPermission>;

  constructor(attributes: Attributes) {
    this.id = attributes.id;
    this.email = attributes.email;
    this.name = attributes.name;
    this.extension = attributes.extension;
    this.isInactive = attributes.isInactive;
    this.cognitoStatus = attributes.cognitoStatus;
    this.permissions = attributes.permissions;
  }

  hasPermission(permission: UserPermission): boolean {
    return this.permissions.has(permission);
  }
}
